import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as Tippy } from 'react-tippy';
import './InfoTip.scss';

import Tooltip from '../../General/Tooltip';

// The (i) beside a label: hover for what the column or control means. A list of paragraphs is the
// longer explainer, with each option's name leading its paragraph.
const InfoTip = ({ message, position = 'bottom' }) =>
  Array.isArray(message) ? (
    <div className='info-tip'>
      <Tippy
        className='tooltip-outer-container'
        html={<TipParagraphs paragraphs={message} />}
        position={position}
        animation='fade'
        size='small'
        arrow
      >
        <span className='info-tip-glyph'>i</span>
      </Tippy>
    </div>
  ) : (
    <Tooltip outerClassName='info-tip' message={message} position={position} getIconDiv={() => <span className='info-tip-glyph'>i</span>} />
  );

const TipParagraphs = ({ paragraphs }) => (
  <div className='info-tip-paragraphs'>
    {paragraphs.map(({ lead, text, muted }) => (
      <p key={lead || text} className={muted ? 'muted' : undefined}>
        {lead && <b>{lead}:</b>} {text}
      </p>
    ))}
  </div>
);

const paragraphShape = PropTypes.shape({ lead: PropTypes.string, text: PropTypes.string.isRequired, muted: PropTypes.bool });

InfoTip.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(paragraphShape)]).isRequired,
  position: PropTypes.string
};

TipParagraphs.propTypes = {
  paragraphs: PropTypes.arrayOf(paragraphShape).isRequired
};

export default InfoTip;
